"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectDestructuringEmpty"));

var _react = _interopRequireDefault(require("react"));

var _FirstColumn = _interopRequireDefault(require("./FirstColumn"));

var _Column = _interopRequireDefault(require("./Column"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function CommonPlate(_ref) {
  (0, _objectDestructuringEmpty2["default"])(_ref);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['wrapper']
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['content']
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['column']
  }, /*#__PURE__*/_react["default"].createElement(_FirstColumn["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['column']
  }, /*#__PURE__*/_react["default"].createElement(_Column["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['column']
  }, /*#__PURE__*/_react["default"].createElement(_Column["default"], null))));
}

var _default = CommonPlate;
exports["default"] = _default;